import { Button } from "primereact/button";
import { getSocket } from '../context/socket'; // adjust the path if needed

const HoldCardPopup = ({ onCancel, cardDetails, togglePopup, cardId, boardId }) => {
    const socket = getSocket();

    const isCurrentlyOnHold = cardDetails?.on_hold;

    const handleToggleHoldStatus = () => {
        if (!cardDetails || !cardDetails.card_id) return;

        socket.emit("toggleCardHoldStatus", {
            card_id: cardId,
            on_hold: !isCurrentlyOnHold, // toggle the current state
            board_id: boardId
        });

        togglePopup("On_Hold"); // Close popup after action
    };

    return (
        <div className="popup-box popup-unhold">
            <div className="popup-header">
                {isCurrentlyOnHold ? 'Unhold Card' : 'Put Card On Hold'}
                <Button
                    icon="pi pi-times"
                    className="p-button-text close-btn"
                    onClick={onCancel}
                />
            </div>
            <div className="popup-body">
                <p>
                    Are you sure you want to {isCurrentlyOnHold ? 'unhold' : 'put'} this card {isCurrentlyOnHold ? 'back in progress' : 'on hold'}?
                </p>
                <div className="d-flex justify-content-end mt-1">
                    <Button
                        label="Cancel"
                        severity="secondary"
                        className="border-0 py-1 px-3 mt-1 me-2"
                        onClick={onCancel}
                    />
                    <Button
                        label={isCurrentlyOnHold ? 'Unhold' : 'Hold'}
                        severity={isCurrentlyOnHold ? 'success' : 'danger'}
                        className="border-0 py-1 px-3 mt-1 me-2"
                        onClick={handleToggleHoldStatus}
                    />
                </div>
            </div>
        </div>
    );
};

export default HoldCardPopup;
